import { render, staticRenderFns } from "./ClienteTab.vue?vue&type=template&id=70083f02"
import script from "./ClienteTab.vue?vue&type=script&lang=js"
export * from "./ClienteTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports